import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class OnboardRebookingService {
  busSvcURL = '';
  OBPortalSvcURL = '';
  OBRebookAgent = '';
  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  public GetCategoriesforShip(evtuid: string | undefined): Observable<any> {
    this.busSvcURL = this.appConfigService.busSvcURL;
    const CruiseShipCategories: JSON = <JSON>(<unknown>{
      eventId: evtuid,
      availIndicator: 0,
      priceIndicator: 1,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.busSvcURL + 'GetCategoriesforShip',
      JSON.stringify(CruiseShipCategories),
      {
        headers: headers,
      }
    );
  }
  public GetRoomsforCategory(
    evtuid: string | undefined,
    CategoryID: number | undefined
  ): Observable<any> {
    this.busSvcURL = this.appConfigService.busSvcURL;
    const CategoryRooms: JSON = <JSON>(<unknown>{
      EventID: evtuid,
      AvailIndicator: 1,
      CategoryID: CategoryID,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.busSvcURL + 'GetRoomsForCategory',
      JSON.stringify(CategoryRooms),
      {
        headers: headers,
      }
    );
  }
  public GetItemsforCruise(
    evtuid: Int16Array | undefined,
    GroupType: string | undefined,
    TypeCode: string | undefined
  ): Observable<any> {
    this.busSvcURL = this.appConfigService.busSvcURL;
    const CruiseItems: JSON = <JSON>(<unknown>{
      evtuid: evtuid,
      GroupType: GroupType,
      TypeCode: TypeCode,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.get<any>(
      this.busSvcURL +
        'GetItemsforCruise&EventID=' +
        evtuid +
        '&GroupType=' +
        GroupType +
        '&TypeCode=' +
        TypeCode
      //JSON.stringify(CruiseItems),
      // {
      //   headers: headers,
      // }
    );
  }
  public GetCFAR(
    evtuid: Int16Array | undefined,
    numfolios: number | undefined,
    CategoryCode: string | undefined,
    discountCode: string | undefined,
    AddItems: {
      ItemId: number | undefined;
      price: number | undefined;
      quantity: number | undefined;
    }[]
  ): Observable<any> {
    this.busSvcURL = this.appConfigService.busSvcURL;
    const CFARItems: JSON = <JSON>(<unknown>{
      eventId: evtuid,
      numfolios: numfolios,
      CategoryCode: CategoryCode,
      discountCode: discountCode,
      AddItems: AddItems,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.busSvcURL + 'GetCFAR',
      JSON.stringify(CFARItems),
      {
        headers: headers,
      }
    );
  }
  public GetOBMarketingType(shpcode: string | undefined): Observable<any> {
    this.busSvcURL = this.appConfigService.busSvcURL;
    const OBMKTItems: JSON = <JSON>(<unknown>{
      shpcode: shpcode,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.busSvcURL + 'GetOnboardMarketingType',
      JSON.stringify(OBMKTItems),
      {
        headers: headers,
      }
    );
  }

  public MakeTentativeBooking(
    evtuid: Int16Array | undefined,
    folioIds: string | undefined,
    CategoryId: number | undefined,
    MarketingType: string | undefined,
    RoomNumber: string | undefined,
    cfarItem: string | undefined,
    deliverytype: string | undefined,
    AddItems: {
      ItemId: number | undefined;
    }[]
  ): Observable<any> {
    this.busSvcURL = this.appConfigService.busSvcURL;
    this.OBRebookAgent = this.appConfigService.OBRebookAgent;

    const CFARItems: JSON = <JSON>(<unknown>{
      eventId: evtuid,
      folioIds: folioIds,
      category: CategoryId,
      agentID: this.OBRebookAgent,
      MarketingType: MarketingType,
      RoomNumber: RoomNumber,
      cfarItem: cfarItem,
      deliverytype: deliverytype,
      AddItems: AddItems,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.busSvcURL + 'MakeTentativeBooking',
      JSON.stringify(CFARItems),
      {
        headers: headers,
      }
    );
  }
  public SaveTentativeBooking(
    evtuid: Int16Array | undefined,
    folioId1: string | undefined,
    folioId2: string | undefined,
    CategoryCode: string | undefined,
    CategoryId: number | undefined,
    CurrentCruiseCode: string | undefined,
    RoomNumber: string | undefined,
    UnitID: number | undefined,
    NewCruiseCode: string | undefined,
    FacilityID: number | undefined,
    FacilityName: string | undefined,
    DepartureDate: string | undefined,
    FullName1: string | undefined,
    FullName2: string | undefined,
    InvoiceID: string | undefined,
    NewBookingID: string | undefined,
    Paymentstatus: string | undefined,
    AddItems: {
      ItemId: number | undefined;
    }[]
  ): Observable<any> {
    this.busSvcURL = this.appConfigService.busSvcURL;
    const CFARItems: JSON = <JSON>(<unknown>{
      NewEventID: evtuid,
      folioId1: folioId1,
      folioId2: folioId2,
      CategoryCode: CategoryCode,
      CategoryID: CategoryId,
      CurrentCruiseCode: CurrentCruiseCode,
      NewCruiseCode: NewCruiseCode,
      UnitCode: RoomNumber,
      UnitID: UnitID,
      FacilityID: FacilityID,
      FacilityName: FacilityName,
      DepartureDate: DepartureDate,
      AddItems: AddItems,
      FullName1: FullName1,
      FullName2: FullName2,
      invoiceID: InvoiceID,
      NewBookingID: NewBookingID,
      Paymentstatus: Paymentstatus,
      AssignAgent: false,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.busSvcURL + 'SaveTentativeBooking',
      JSON.stringify(CFARItems),
      {
        headers: headers,
      }
    );
  }
  public ChangeBookingStatusT2(bookingId: number | undefined): Observable<any> {
    this.busSvcURL = this.appConfigService.busSvcURL;
    const bookingitems: JSON = <JSON>(<unknown>{
      BookingId: bookingId,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.busSvcURL + 'ChangeBookingStatusT2',
      JSON.stringify(bookingitems),
      {
        headers: headers,
      }
    );
  }
  public GetBookingPrice(bookingId: string | undefined): Observable<any> {
    this.busSvcURL = this.appConfigService.busSvcURL;
    const bookingitems: JSON = <JSON>(<unknown>{
      bookingId: bookingId,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.busSvcURL + 'GetBookingPrice',
      JSON.stringify(bookingitems),
      {
        headers: headers,
      }
    );
  }
  public GetBookingBalance(rebuid: string | undefined): Observable<any> {
    this.busSvcURL = this.appConfigService.busSvcURL;
    const bookingitems: JSON = <JSON>(<unknown>{
      rebuid: rebuid,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.busSvcURL + 'GetBookingBalLive',
      JSON.stringify(bookingitems),
      {
        headers: headers,
      }
    );
  }
  public getBookingTransactions(rebuid: number | undefined): Observable<any> {
    this.busSvcURL = this.appConfigService.busSvcURL;
    const bookingitems: JSON = <JSON>(<unknown>{
      includecommission: false,
      includepayment: false,
      rebuid: rebuid,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.busSvcURL + 'GetBookingTransactions',
      JSON.stringify(bookingitems),
      {
        headers: headers,
      }
    );
  }
  public getCFARBooking(
    rebuid: number | undefined,
    eventId: Int16Array | undefined,
    numfolios: number | undefined
  ): Observable<any> {
    this.busSvcURL = this.appConfigService.busSvcURL;
    const bookingitems: JSON = <JSON>(<unknown>{
      BookingId: rebuid,
      EventID: eventId,
      numfolios: numfolios,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.busSvcURL + 'GetCFARBooking',
      JSON.stringify(bookingitems),
      {
        headers: headers,
      }
    );
  }

  public SendTentativeNotification(
    shipId: number | 0,
    FullName1: string | undefined,
    FullName2: string | undefined,
    ItineraryName: string | undefined,
    ShipName: string | undefined,
    traveldates: string | undefined,
    rebuid: number | undefined
  ): Observable<any> {
    var guestnames = '';
    if (FullName1 != undefined) {
      guestnames = FullName1;
      if (FullName2 != undefined) guestnames = guestnames + ',' + FullName2;
    } else if (FullName2 != undefined) guestnames = FullName2;

    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    const CFARItems: JSON = <JSON>(<unknown>{
      shpId: shipId,
      GuestNames: guestnames,
      ItineraryName: ItineraryName,
      ShipName: ShipName,
      traveldates: traveldates,
      rebuid: rebuid,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.OBPortalSvcURL + 'SendTentativeNotification',
      JSON.stringify(CFARItems),
      {
        headers: headers,
      }
    );
  }
}
